import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../../Components/footer";
import PlayerNav from "./player_nav";

const PlayerDashboard = () => {
	const navigate = useNavigate();
	const [user, setUser] = useState();
	useEffect(() => {
		const storedUser = localStorage.getItem("nguser");

		if (storedUser) {
			const player = JSON.parse(storedUser);
			setUser(player);
		} else {
			navigate("/");
		}
	}, []);

	useEffect(() => {
		if (user && user.role !== "player") {
			console.warn(
				"Non-player user attempted to access admin dashboard.",
			);
			localStorage.removeItem("nguser");
			navigate("/");
		}
	}, [user, navigate]);

	return (
		<div className="w-screen flex flex-col justify-center items-center">
			<PlayerNav />
			<main className="w-screen px-4 md:px-20 pt-10 mt-16 lg:mt-20">
				<p className="text-2xl lg:text-5xl font-semibold text-gray-400">
					Welcome
				</p>
				<p className="text-3xl lg:text-7xl font-bold mt-4 lg:mt-8 text-gray-200">
					{user && user.name}
				</p>

				<div className="flex flex-col lg:flex-row lg:justify-around gap-10 mt-10 lg:mt-20">
					<div
						onClick={() => navigate("/player/sessions")}
						className="relative flex justify-center items-end rounded-3xl shadow-lg transition durationn-300 hover:shadow-cyan-500/50 overflow-hidden cursor-pointer w-full h-96"
					>
						<img
							src="/player_yc.jpeg"
							alt="Your Sessions"
							className="absolute inset-0 w-full h-full object-cover"
						/>
						<p className="absolute bottom-8 z-10 flex items-center justify-center text-white text-4xl md:text-6xl font-bold bg-transparent">
							Your Sessions
						</p>
					</div>
					<div
						onClick={() => navigate("/player/calendar")}
						className="relative flex justify-center items-end rounded-3xl shadow-lg transition durationn-300 hover:shadow-cyan-500/50 overflow-hidden cursor-pointer w-full h-96"
					>
						<img
							src="/player_c.jpeg"
							alt="Calendar"
							className="absolute inset-0 w-full h-full object-cover"
						/>
						<p className="absolute bottom-8 z-10 flex items-center justify-center text-white text-4xl md:text-6xl font-bold bg-transparent">
							Calendar
						</p>
					</div>
				</div>
			</main>
			<Footer />
		</div>
	);
};

export default PlayerDashboard;
